import React, { useState } from 'react';
import { expenseService, ExpenseInput } from '../../services/expenseService';
import { toast } from 'react-hot-toast';

interface Props {
  onCreated?: () => void;
}

const ExpenseEntryForm: React.FC<Props> = ({ onCreated }) => {
  const [form, setForm] = useState<ExpenseInput>({
    date: new Date().toISOString().slice(0, 10),
    amount: 0,
    currency: 'GBP',
    category: '',
    vendor: '',
    notes: '',
    is_fixed: false,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: name === 'amount' ? Number(value) : value }));
  };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!form.date || !form.amount) throw new Error('Date and amount are required');
      await expenseService.create(form);
      toast.success('Expense recorded');
      setForm(f => ({ ...f, amount: 0, category: '', vendor: '', notes: '' }));
      onCreated?.();
    } catch (err: any) {
      toast.error(err.message || 'Failed to save expense');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="bg-white p-4 rounded shadow space-y-3">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div>
          <label className="block text-sm font-medium">Date</label>
          <input type="date" name="date" value={form.date} onChange={handleChange} className="mt-1 w-full border rounded p-2" />
        </div>
        <div>
          <label className="block text-sm font-medium">Amount</label>
          <input type="number" name="amount" value={form.amount} onChange={handleChange} className="mt-1 w-full border rounded p-2" step="0.01" />
        </div>
        <div>
          <label className="block text-sm font-medium">Currency</label>
          <input type="text" name="currency" value={form.currency} onChange={handleChange} className="mt-1 w-full border rounded p-2" />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div>
          <label className="block text-sm font-medium">Category</label>
          <input type="text" name="category" value={form.category} onChange={handleChange} className="mt-1 w-full border rounded p-2" />
        </div>
        <div>
          <label className="block text-sm font-medium">Vendor</label>
          <input type="text" name="vendor" value={form.vendor} onChange={handleChange} className="mt-1 w-full border rounded p-2" />
        </div>
        <div>
          <label className="block text-sm font-medium">Notes</label>
          <input type="text" name="notes" value={form.notes} onChange={handleChange} className="mt-1 w-full border rounded p-2" />
        </div>
      </div>
      <div>
        <label className="inline-flex items-center space-x-2">
          <input type="checkbox" checked={!!form.is_fixed} onChange={e => setForm(prev => ({ ...prev, is_fixed: e.target.checked }))} />
          <span>Fixed cost</span>
        </label>
      </div>
      <div>
        <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Saving...' : 'Add Expense'}</button>
      </div>
    </form>
  );
};

export default ExpenseEntryForm;
